// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.summary.RentalManagerUserPropertySummaryWebApiHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertySummaryWebApiHandler_applications,
  RentalManagerUserPropertySummaryWebApiHandler_applications_Path,
  RentalManagerUserPropertySummaryWebApiHandler_leases,
  RentalManagerUserPropertySummaryWebApiHandler_leases_Path,
  RentalManagerUserPropertySummaryWebApiHandler_listing,
  RentalManagerUserPropertySummaryWebApiHandler_listing_Path,
  RentalManagerUserPropertySummaryWebApiHandler_maintenance,
  RentalManagerUserPropertySummaryWebApiHandler_maintenance_Path,
  RentalManagerUserPropertySummaryWebApiHandler_nextSteps,
  RentalManagerUserPropertySummaryWebApiHandler_nextSteps_Path,
  RentalManagerUserPropertySummaryWebApiHandler_payments,
  RentalManagerUserPropertySummaryWebApiHandler_payments_Path,
  RentalManagerUserPropertySummaryWebApiHandler_propertyConditions,
  RentalManagerUserPropertySummaryWebApiHandler_propertyConditions_Path,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  ListingAlias,
  UserPropertySummaryApplicationsResponseWebDto,
  UserPropertySummaryLeasesResponseWebDto,
  UserPropertySummaryListingResponseWebDto,
  UserPropertySummaryMaintenanceResponseWebDto,
  UserPropertySummaryNextStepsResponseWebDto,
  UserPropertySummaryPaymentsResponseWebDto,
  UserPropertySummaryPropertyConditionsResponseWebDto,
} from '@zg-rentals/ts-rental-manager-api-client';

interface ApplicationsParams {
  getActive?: boolean;
  listingAlias: ListingAlias;
}
interface LeasesParams {
  listingAlias: ListingAlias;
}
interface ListingParams {
  listingAlias: ListingAlias;
}
interface MaintenanceParams {
  listingAlias: ListingAlias;
}
interface NextStepsParams {
  listingAlias: ListingAlias;
}
interface PaymentsParams {
  listingAlias: ListingAlias;
}
interface PropertyConditionsParams {
  listingAlias: ListingAlias;
}

export type RentalManagerUserPropertySummaryWebApiHandler_applications_Options = UseQueryOptions<
  UserPropertySummaryApplicationsResponseWebDto,
  unknown,
  UserPropertySummaryApplicationsResponseWebDto,
  readonly [string, ApplicationsParams]
>;

const RentalManagerUserPropertySummaryWebApiHandler_applications_GetKey = (getParams: ApplicationsParams) =>
  [RentalManagerUserPropertySummaryWebApiHandler_applications_Path, getParams] as const;

export const RentalManagerUserPropertySummaryWebApiHandler_applications_queryOptions = (
  getParams: ApplicationsParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertySummaryWebApiHandler_applications_GetKey(getParams),
    queryFn: () => RentalManagerUserPropertySummaryWebApiHandler_applications(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Listing summary from Applications. To be used for Interested Renters module
 */
export const useRentalManagerUserPropertySummaryWebApiHandler_applications = (
  getParams: ApplicationsParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserPropertySummaryWebApiHandler_applications_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertySummaryWebApiHandler_applications_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserPropertySummaryWebApiHandler_applications.getKey =
  RentalManagerUserPropertySummaryWebApiHandler_applications_GetKey;

export type RentalManagerUserPropertySummaryWebApiHandler_leases_Options = UseQueryOptions<
  UserPropertySummaryLeasesResponseWebDto,
  unknown,
  UserPropertySummaryLeasesResponseWebDto,
  readonly [string, LeasesParams]
>;

const RentalManagerUserPropertySummaryWebApiHandler_leases_GetKey = (getParams: LeasesParams) =>
  [RentalManagerUserPropertySummaryWebApiHandler_leases_Path, getParams] as const;

export const RentalManagerUserPropertySummaryWebApiHandler_leases_queryOptions = (
  getParams: LeasesParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertySummaryWebApiHandler_leases_GetKey(getParams),
    queryFn: () => RentalManagerUserPropertySummaryWebApiHandler_leases(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Listing summary from Leases
 */
export const useRentalManagerUserPropertySummaryWebApiHandler_leases = (
  getParams: LeasesParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserPropertySummaryWebApiHandler_leases_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertySummaryWebApiHandler_leases_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserPropertySummaryWebApiHandler_leases.getKey =
  RentalManagerUserPropertySummaryWebApiHandler_leases_GetKey;

export type RentalManagerUserPropertySummaryWebApiHandler_listing_Options = UseQueryOptions<
  UserPropertySummaryListingResponseWebDto,
  unknown,
  UserPropertySummaryListingResponseWebDto,
  readonly [string, ListingParams]
>;

const RentalManagerUserPropertySummaryWebApiHandler_listing_GetKey = (getParams: ListingParams) =>
  [RentalManagerUserPropertySummaryWebApiHandler_listing_Path, getParams] as const;

export const RentalManagerUserPropertySummaryWebApiHandler_listing_queryOptions = (
  getParams: ListingParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertySummaryWebApiHandler_listing_GetKey(getParams),
    queryFn: () => RentalManagerUserPropertySummaryWebApiHandler_listing(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get listing summary
 */
export const useRentalManagerUserPropertySummaryWebApiHandler_listing = (
  getParams: ListingParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserPropertySummaryWebApiHandler_listing_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertySummaryWebApiHandler_listing_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserPropertySummaryWebApiHandler_listing.getKey =
  RentalManagerUserPropertySummaryWebApiHandler_listing_GetKey;

export type RentalManagerUserPropertySummaryWebApiHandler_maintenance_Options = UseQueryOptions<
  UserPropertySummaryMaintenanceResponseWebDto,
  unknown,
  UserPropertySummaryMaintenanceResponseWebDto,
  readonly [string, MaintenanceParams]
>;

const RentalManagerUserPropertySummaryWebApiHandler_maintenance_GetKey = (getParams: MaintenanceParams) =>
  [RentalManagerUserPropertySummaryWebApiHandler_maintenance_Path, getParams] as const;

export const RentalManagerUserPropertySummaryWebApiHandler_maintenance_queryOptions = (
  getParams: MaintenanceParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertySummaryWebApiHandler_maintenance_GetKey(getParams),
    queryFn: () => RentalManagerUserPropertySummaryWebApiHandler_maintenance(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Listing summary from maintenance tracker
 */
export const useRentalManagerUserPropertySummaryWebApiHandler_maintenance = (
  getParams: MaintenanceParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserPropertySummaryWebApiHandler_maintenance_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertySummaryWebApiHandler_maintenance_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserPropertySummaryWebApiHandler_maintenance.getKey =
  RentalManagerUserPropertySummaryWebApiHandler_maintenance_GetKey;

export type RentalManagerUserPropertySummaryWebApiHandler_nextSteps_Options = UseQueryOptions<
  UserPropertySummaryNextStepsResponseWebDto,
  unknown,
  UserPropertySummaryNextStepsResponseWebDto,
  readonly [string, NextStepsParams]
>;

const RentalManagerUserPropertySummaryWebApiHandler_nextSteps_GetKey = (getParams: NextStepsParams) =>
  [RentalManagerUserPropertySummaryWebApiHandler_nextSteps_Path, getParams] as const;

export const RentalManagerUserPropertySummaryWebApiHandler_nextSteps_queryOptions = (
  getParams: NextStepsParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertySummaryWebApiHandler_nextSteps_GetKey(getParams),
    queryFn: () => RentalManagerUserPropertySummaryWebApiHandler_nextSteps(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Listing summary next steps
 */
export const useRentalManagerUserPropertySummaryWebApiHandler_nextSteps = (
  getParams: NextStepsParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserPropertySummaryWebApiHandler_nextSteps_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertySummaryWebApiHandler_nextSteps_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserPropertySummaryWebApiHandler_nextSteps.getKey =
  RentalManagerUserPropertySummaryWebApiHandler_nextSteps_GetKey;

export type RentalManagerUserPropertySummaryWebApiHandler_payments_Options = UseQueryOptions<
  UserPropertySummaryPaymentsResponseWebDto,
  unknown,
  UserPropertySummaryPaymentsResponseWebDto,
  readonly [string, PaymentsParams]
>;

const RentalManagerUserPropertySummaryWebApiHandler_payments_GetKey = (getParams: PaymentsParams) =>
  [RentalManagerUserPropertySummaryWebApiHandler_payments_Path, getParams] as const;

export const RentalManagerUserPropertySummaryWebApiHandler_payments_queryOptions = (
  getParams: PaymentsParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertySummaryWebApiHandler_payments_GetKey(getParams),
    queryFn: () => RentalManagerUserPropertySummaryWebApiHandler_payments(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Listing summary from Payments
 */
export const useRentalManagerUserPropertySummaryWebApiHandler_payments = (
  getParams: PaymentsParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserPropertySummaryWebApiHandler_payments_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertySummaryWebApiHandler_payments_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserPropertySummaryWebApiHandler_payments.getKey =
  RentalManagerUserPropertySummaryWebApiHandler_payments_GetKey;

export type RentalManagerUserPropertySummaryWebApiHandler_propertyConditions_Options = UseQueryOptions<
  UserPropertySummaryPropertyConditionsResponseWebDto,
  unknown,
  UserPropertySummaryPropertyConditionsResponseWebDto,
  readonly [string, PropertyConditionsParams]
>;

const RentalManagerUserPropertySummaryWebApiHandler_propertyConditions_GetKey = (getParams: PropertyConditionsParams) =>
  [RentalManagerUserPropertySummaryWebApiHandler_propertyConditions_Path, getParams] as const;

export const RentalManagerUserPropertySummaryWebApiHandler_propertyConditions_queryOptions = (
  getParams: PropertyConditionsParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertySummaryWebApiHandler_propertyConditions_GetKey(getParams),
    queryFn: () => RentalManagerUserPropertySummaryWebApiHandler_propertyConditions(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Listing summary from Property Condition
 */
export const useRentalManagerUserPropertySummaryWebApiHandler_propertyConditions = (
  getParams: PropertyConditionsParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserPropertySummaryWebApiHandler_propertyConditions_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertySummaryWebApiHandler_propertyConditions_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserPropertySummaryWebApiHandler_propertyConditions.getKey =
  RentalManagerUserPropertySummaryWebApiHandler_propertyConditions_GetKey;
